import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    cta: 'w-full'
  },
  previousNextVariant: 'tertiary',
  showPageSize: true,
  showProgressBar: true
} satisfies RecursivePartial<ProductConfig['pagination']>
